import { render, staticRenderFns } from "./TgAnnounceReviewDialog.vue?vue&type=template&id=7db7c35e"
import script from "./TgAnnounceReviewDialog.vue?vue&type=script&lang=js"
export * from "./TgAnnounceReviewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports